import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Container from "@scentregroup/ui/components/container";
import Paragraph from "@scentregroup/ui/components/paragraph";
import Feature from '../../feature';
import FlipFlop from '../../flip-flop';
import Article from '../../article';
import Jenga from '../../jenga';
import FullWidth from '../../full-width';
import { HalfHalf, Half } from '../../half-half';
import Accordion from '../../accordion';
import { Deck, DeckCard } from '../../deck';
import FeaturedContent from '../../featured-content';
import PageHeading from '../../page-heading';
import SectionHeading from '../../section-heading';
import FilteredCardList from '../../filtered-card-list';
import Promotion from '../../promotion';
import SocialFeed from '../../social-feed';
import Reviews from '../../reviews';
import CentreUtilityBox from '../../centre-utility-box';
import ComparisonItem from '../../comparison-item';
import { SpotlightModule } from '../../spotlight';
import { PromotionPositionContext } from '../../../context';
import { MarketplaceContainer } from '../../marketplace-container';
import { MarketplaceDeckContainer } from '../../marketplace-deck-container';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

const Module = ({
  moduleProps,
  lazyLoad
}) => {
  var _moduleProps$analytic, _moduleProps$analytic2, _moduleProps$analytic3, _moduleProps$analytic4, _moduleProps$analytic5, _moduleProps$analytic6, _moduleProps$analytic7, _moduleProps$analytic8;

  switch (moduleProps.displayMode) {
    case 'Feature':
      return /*#__PURE__*/_jsx(PromotionPositionContext.Provider, {
        value: moduleProps === null || moduleProps === void 0 ? void 0 : (_moduleProps$analytic = moduleProps.analyticsMetadata) === null || _moduleProps$analytic === void 0 ? void 0 : _moduleProps$analytic.displayId,
        children: /*#__PURE__*/_jsx(Feature, _objectSpread(_objectSpread({
          lazyLoad: lazyLoad
        }, moduleProps), {}, {
          analyticsMetadata: moduleProps.entryAnalyticsMetadata
        }))
      });

    case 'UtilityPanel':
      return /*#__PURE__*/_jsx(CentreUtilityBox, _objectSpread({}, moduleProps));

    case 'Flip Flop':
      return /*#__PURE__*/_jsx(PromotionPositionContext.Provider, {
        value: moduleProps === null || moduleProps === void 0 ? void 0 : (_moduleProps$analytic2 = moduleProps.analyticsMetadata) === null || _moduleProps$analytic2 === void 0 ? void 0 : _moduleProps$analytic2.displayId,
        children: /*#__PURE__*/_jsx(Container, {
          centred: true,
          type: "large",
          children: /*#__PURE__*/_jsx(FlipFlop, _objectSpread(_objectSpread({
            lazyLoad: lazyLoad
          }, moduleProps), {}, {
            analyticsMetadata: moduleProps.entryAnalyticsMetadata,
            children: /*#__PURE__*/_jsx(Article, _objectSpread(_objectSpread({}, moduleProps), {}, {
              children: /*#__PURE__*/_jsx(Paragraph, {
                children: moduleProps.body
              })
            }))
          }))
        })
      });

    case 'Half Half (With Image)':
    case 'Half Half (Text Only)':
      return /*#__PURE__*/_jsx(PromotionPositionContext.Provider, {
        value: moduleProps === null || moduleProps === void 0 ? void 0 : (_moduleProps$analytic3 = moduleProps.analyticsMetadata) === null || _moduleProps$analytic3 === void 0 ? void 0 : _moduleProps$analytic3.displayId,
        children: /*#__PURE__*/_jsx(MarketplaceContainer, {
          children: /*#__PURE__*/_jsx(HalfHalf, {
            children: moduleProps.entries.map(entry => /*#__PURE__*/_createElement(Half, _objectSpread(_objectSpread({}, entry), {}, {
              key: entry.id,
              lazyLoad: lazyLoad,
              headingType: "small"
            })))
          })
        })
      });

    case 'Full Width (With Image)':
    case 'Full Width (Text Only)':
      return /*#__PURE__*/_jsx(PromotionPositionContext.Provider, {
        value: moduleProps === null || moduleProps === void 0 ? void 0 : (_moduleProps$analytic4 = moduleProps.analyticsMetadata) === null || _moduleProps$analytic4 === void 0 ? void 0 : _moduleProps$analytic4.displayId,
        children: /*#__PURE__*/_jsx(Container, {
          centred: true,
          type: "large",
          children: /*#__PURE__*/_jsx(FullWidth, _objectSpread(_objectSpread({
            lazyLoad: lazyLoad
          }, moduleProps), {}, {
            analyticsMetadata: moduleProps.entryAnalyticsMetadata
          }))
        })
      });

    case 'Accordion':
      return /*#__PURE__*/_jsx(Container, {
        centred: true,
        type: "large",
        children: /*#__PURE__*/_jsx(Accordion, _objectSpread({}, moduleProps))
      });

    case 'Featured Content':
      return /*#__PURE__*/_jsx(PromotionPositionContext.Provider, {
        value: moduleProps === null || moduleProps === void 0 ? void 0 : (_moduleProps$analytic5 = moduleProps.analyticsMetadata) === null || _moduleProps$analytic5 === void 0 ? void 0 : _moduleProps$analytic5.displayId,
        children: /*#__PURE__*/_jsx(FeaturedContent, {
          color: moduleProps.color,
          title: moduleProps.title,
          children: (moduleProps.entries || []).map(entry => /*#__PURE__*/_createElement(DeckCard, _objectSpread(_objectSpread({}, entry), {}, {
            key: entry.id
          })))
        })
      });

    case 'Jenga':
      return /*#__PURE__*/_jsx(Jenga, _objectSpread({}, moduleProps));

    case 'Deck':
      return /*#__PURE__*/_jsx(PromotionPositionContext.Provider, {
        value: moduleProps === null || moduleProps === void 0 ? void 0 : (_moduleProps$analytic6 = moduleProps.analyticsMetadata) === null || _moduleProps$analytic6 === void 0 ? void 0 : _moduleProps$analytic6.displayId,
        children: /*#__PURE__*/_jsx(MarketplaceDeckContainer, {
          children: /*#__PURE__*/_jsx(Deck, _objectSpread(_objectSpread({}, moduleProps), {}, {
            children: (moduleProps.entries || []).map(entry => /*#__PURE__*/_createElement(DeckCard, _objectSpread(_objectSpread({}, entry), {}, {
              key: entry.id
            })))
          }))
        })
      });

    case 'Page Heading':
      return /*#__PURE__*/_jsx(PageHeading, _objectSpread({}, moduleProps));

    case 'Section Heading':
      return /*#__PURE__*/_jsx(SectionHeading, _objectSpread({}, moduleProps));

    case 'Promotion':
      return /*#__PURE__*/_jsx(Container, {
        centred: true,
        type: "large",
        children: /*#__PURE__*/_jsx(Promotion, _objectSpread({}, moduleProps))
      });

    case 'FilteredCardList':
      return /*#__PURE__*/_jsx(FilteredCardList, _objectSpread({}, moduleProps));

    case 'SocialFeed':
      return /*#__PURE__*/_jsx(SocialFeed, _objectSpread({}, moduleProps));

    case 'CentreReviews':
      return /*#__PURE__*/_jsx(Reviews, _objectSpread({}, moduleProps));

    case 'News':
      return /*#__PURE__*/_jsx(PromotionPositionContext.Provider, {
        value: moduleProps === null || moduleProps === void 0 ? void 0 : (_moduleProps$analytic7 = moduleProps.analyticsMetadata) === null || _moduleProps$analytic7 === void 0 ? void 0 : _moduleProps$analytic7.displayId,
        children: /*#__PURE__*/_jsx(SpotlightModule, {
          useAlternateDesign: true,
          moduleProps: moduleProps
        })
      });

    case 'Comparison Item':
      return /*#__PURE__*/_jsx(Container, {
        centred: true,
        type: "large",
        children: /*#__PURE__*/_jsx(HalfHalf, {
          children: moduleProps.entries.map(entry => /*#__PURE__*/_createElement(ComparisonItem, _objectSpread(_objectSpread({}, entry), {}, {
            key: entry.productName
          })))
        })
      });

    case 'Spotlight':
    default:
      return /*#__PURE__*/_jsx(PromotionPositionContext.Provider, {
        value: moduleProps === null || moduleProps === void 0 ? void 0 : (_moduleProps$analytic8 = moduleProps.analyticsMetadata) === null || _moduleProps$analytic8 === void 0 ? void 0 : _moduleProps$analytic8.displayId,
        children: /*#__PURE__*/_jsx(SpotlightModule, {
          moduleProps: moduleProps
        })
      });
  }
};

Module.defaultProps = {
  lazyLoad: true
};
export default Module;